export type StandCroquis = { id: string; x: number; y: number; largeur: number; profondeur: number };

// shortcut: unités du croquis et identifiants provisoires, remplacer après réception du plan coté validé.
const rectangles: number[][] = [];
function rangee(xs: number[][], y: number, profondeur = 62): void {
  for (const [x = 0, largeur = 0] of xs) rectangles.push([x, y, largeur, profondeur]);
}
const haut = [[16, 102], [118, 102], [220, 102], [322, 102], [424, 132], [556, 103], [659, 102]];
rangee(haut, 98);
rangee(haut, 160);
rangee(haut.slice(1), 280);
rangee(haut.slice(1), 342);
rangee([[0, 62]], 246, 102);
rangee([[0, 62]], 348, 102);
for (const y of [40, 142, 244, 346]) rangee([[901, 62]], y, 102);
rangee([[118, 102], [220, 102], [322, 102], [491, 102], [593, 102], [695, 102], [797, 102]], 450);
rangee([[90, 102], [192, 132], [324, 100], [491, 102]], 512);
rangee([[90, 102], [192, 102], [294, 102], [396, 95], [491, 102]], 616);

export const STANDS_CROQUIS: StandCroquis[] = rectangles.map(([x = 0, y = 0, largeur = 0, profondeur = 0], i) => ({
  id: `P${String(i + 1).padStart(2, "0")}`, x, y, largeur, profondeur,
}));
